import Cookies from 'js-cookie';

export enum EWebViewActions {
  CLOSE_WEB_VIEW = 'close_webview',
}

export interface IWebViewActionData {
  action: EWebViewActions;
  action_value: {
    url?: string;
  } | null;
}

export function UseWebviewCallback(
  data: IWebViewActionData,
  nativeWebFunc: () => void,
  getRes?: (res: any) => void
) {
  try {
    const isWebView = Boolean(Cookies.get('webview'));

    if (isWebView && data?.action) {
      if (
        typeof window !== 'undefined' &&
        (window as any)?.flutter_inappwebview?.callHandler
      ) {
        (window as any)
          .flutter_inappwebview.callHandler('WebViewConnect', JSON.stringify(data))
          .then((res: any) => {
            getRes?.(res);
          })
          .catch(() => {
            nativeWebFunc();
          });
        return;
      }
    }

    nativeWebFunc();
  } catch (e) {
    nativeWebFunc();
  }
}


export const closeWebView = (fallback: () => void) => {
  UseWebviewCallback(
    {
      action: EWebViewActions.CLOSE_WEB_VIEW,
      action_value: null,
    },
    fallback
  );
};
